/**
 * 原生App桥接工具
 * 在WKWebView环境下通过messageHandler调用原生功能
 */

const NativeBridge = {
  isNative: () => !!window.__NATIVE_APP__,

  // 分享订单信息
  shareOrder: (orderData) => {
    if (!window.webkit?.messageHandlers?.shareOrder) return false;
    window.webkit.messageHandlers.shareOrder.postMessage({
      tracking_number: orderData.tracking_number || '',
      product: orderData.product || '',
      color: orderData.color || '',
      quantity: String(orderData.quantity || ''),
      status: orderData.status || '',
      note: orderData.note || '',
      texts: orderData.texts || '',
      image: orderData.image || '',
    });
    return true;
  },

  // 保存图片到相册
  saveImage: (url) => {
    if (!window.webkit?.messageHandlers?.saveImage) return false;
    window.webkit.messageHandlers.saveImage.postMessage({ url });
    return true;
  },

  // 更新角标数字
  updateBadge: (count) => {
    if (!window.webkit?.messageHandlers?.updateBadge) return false;
    window.webkit.messageHandlers.updateBadge.postMessage({ count });
    return true;
  },

  // 长按图片保存到相册（原生App）。返回清理函数，组件卸载时调用以移除监听
  setupLongPressSave: () => {
    if (!NativeBridge.isNative()) return () => {};
    let longPressTimer = null;
    const onStart = (e) => {
      const img = e.target.closest('img');
      if (!img || !img.src) return;
      longPressTimer = setTimeout(() => NativeBridge.saveImage(img.src), 600);
    };
    const onEnd = () => clearTimeout(longPressTimer);
    document.addEventListener('touchstart', onStart, { passive: true });
    document.addEventListener('touchend', onEnd, { passive: true });
    document.addEventListener('touchmove', onEnd, { passive: true });
    return () => {
      document.removeEventListener('touchstart', onStart);
      document.removeEventListener('touchend', onEnd);
      document.removeEventListener('touchmove', onEnd);
      if (longPressTimer) clearTimeout(longPressTimer);
    };
  },

  // 监听原生toast。返回清理函数，组件卸载时调用以移除监听
  onNativeToast: (callback) => {
    const handler = (e) => callback(e.detail);
    window.addEventListener('nativeToast', handler);
    return () => window.removeEventListener('nativeToast', handler);
  },

  // 查询生物识别支持
  isBiometricSupported: () => NativeBridge.isNative(),
};

export default NativeBridge;
